import { TRANSITION_GROUP } from '@vue/compiler-dom';
import {api, headers} from './api';

const RESOURCE = 'pengusulan_anggota';

export const dataPengusulanAnggota = (tr_pengusulan_id) => api.get(RESOURCE+'/data/'+tr_pengusulan_id, headers);

export const storePengusulanAnggota = (data) => api.post(RESOURCE, data, headers);

export const deletePengusulanAnggota = (id) => api.delete(RESOURCE+'/'+id, headers);